import CardDiv from "modules/common/card-div/CardDiv";
import React, { useEffect, useState } from "react";
import corner1 from "assets/img/illustrations/corner-1.png";
import Background from "modules/common/Background";

function BookingStats({ stats }) {
  const [doctorStats, setDoctorStats] = useState({});
  useEffect(() => {
    setDoctorStats(stats);
  }, [doctorStats]);
  return (
    <div className="d-flex gap-3 flex-wrap pt-2 w-100">
      {Object.entries(doctorStats)?.map(([day, slots]) => {
        return (
          <div className="flex-1">
            <CardDiv
              title={<div className="fs-1">{day}</div>}
              component={
                <>
                  <Background
                    image={corner1}
                    style={{
                      borderTopRightRadius: "0.375rem",
                      borderBottomRightRadius: "0.375rem",
                    }}
                  />
                  <ul className="my-n1">
                    <li>
                      <span className="flex-1 text-black fw-bold">
                      Answered : {slots["Answered"]}
                      </span>
                    </li>
                    <li>
                      <span className="flex-1 text-black fw-bold">
                        Not Answered : {slots["Not Answered"]}
                      </span>
                    </li>
                    <li>
                      <span className="flex-1 text-black fw-bold">
                        Unfinished : {slots["Unfinished"]}
                      </span>
                    </li>
                  </ul>
                </>
              }
            />
          </div>
        );
      })}
    </div>
  );
}

export default BookingStats;
